"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSManageAccountComponent = void 0;
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
class CSManageAccountComponent {
    constructor(accountDetailService, accountService) {
        this.accountDetailService = accountDetailService;
        this.accountService = accountService;
    }
    ngOnInit() {
        this.showForm = true;
        this.getErrorMessage();
    }
    submitSecondaryAccountInformation(value) {
        this.loader = true;
        this.accountDetailService.validateSecondaryToPrimary(value)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.showForm = true;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
}
exports.CSManageAccountComponent = CSManageAccountComponent;
//# sourceMappingURL=manageaccount.component.js.map